import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      isPlaying: false,
      //播放按钮开关
      currentIndex: 0,
      //目前在播放的audio
      audioPath: '',
      prevIndex: 0,
      //上次播放实例
      process: 0 //音频进度
    };
  },
  props: ['audioList', 'formData', 'language', 'version'],
  methods: {
    clickPlay(index, item) {
      if (this.currentIndex != index) this.audioPath = '';
      this.isPlaying && this.currentIndex === index ? this.stopAudio(index) : this.playAudio(index);
    },
    getAudioDetail(item) {
      let query = this.$route.query;
      query.location = item.exhibitionLocation;
      delete query.exhibCode;
      this.$router.push({
        path: `/audioDetail/${item.code}`,
        query
      });
    },
    stopAudio(index) {
      this.$refs.audioItem.pause();
      this.currentIndex = index;
      this.isPlaying = false;
    },
    playAudio(index) {
      index === this.prevIndex ? console.log('继续播放') : this.process = 0;
      this.setAudioPath(this.audioList[index].audioPath, index);
    },
    setAudioPath(audioPath, index) {
      if (!audioPath) return;
      this.$api.getUrlByObjectId(audioPath).then(res => {
        this.audioPath = res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
        this.$nextTick(() => {
          this.$refs.audioItem.play();
        });
        this.currentIndex = index;
        this.prevIndex = index;
        this.isPlaying = true;
      });
    }
  },
  computed: {}
};